import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@babackapp/ui/components/dialog";
import { useEffect, useState } from "react";
import useShop from "@babackapp/private-api-client/client/use-shop";
import { useParams } from "react-router-dom";

export default function BillingWarningPopup() {
  const params = useParams<{ shopId: string }>();
  const shopId = params.shopId || "";
  const { data: shop } = useShop(shopId);

  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (shop?.billing.stripe.warningNotPaying) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [shop]);

  if (!open) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogTitle>
          <div className="font-bold text-lg">Attention facturation</div>
        </DialogTitle>
        <DialogDescription asChild>
          <div className="space-y-2">
            <div>Bonjour,</div>
            <div>
              Baback émet ses factures le 1er de chaque mois, avec un règlement
              à 30 jours. Le respect de ces délais est essentiel au bon
              fonctionnement de notre service.
            </div>
            <div>
              - BABACK SAS facture l'utilisation du logiciel.
              <br />- BABACK LOG SAS facture, le cas échéant, le transport
              retour.
            </div>
            <div>
              À ce jour, au moins une facture reste impayée. Nous vous demandons
              de bien vouloir régulariser la situation sous 5 jours ouvrés afin
              d'éviter l'interruption du service.
            </div>
            <div>
              En cas d'erreur de notre part ou si vous avez déjà réglé, merci de
              nous contacter rapidement.
            </div>
            <div>Merci de votre compréhension.</div>
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}
